import { createContext } from 'react';
const defaultMDXPageContext = false;
export const MDXLayoutContext = /*#__PURE__*/createContext(defaultMDXPageContext);

/**
 * Contextual provider that wraps the `MDXPage` component. Pass in a boolean
 * to reflect whether this is the MDX page. Currently used to apply negative
 * `GutterContainer` styles, which only exist on routes using the MDX layout.
 *
 * @example
 * ```tsx
 * <MDXLayoutContextProvider value={true}>
 *   // ... MDX page
 * </MDXLayoutContextProvider>
 * ```
 */
const {
  Provider
} = MDXLayoutContext;
export { Provider as MDXLayoutContextProvider };